import { IToast, IToasts } from "./types"
import { atom } from "recoil";

export const toastsAtom = atom<IToasts>({
  key: 'toasts',
  default: {
      toasts: [] as IToast[]
  }
});